import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000;
  opacity: 0.7;
  z-index: 10000;
`;
